"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var core_1 = require("@unform/core");
var styles_1 = require("./styles");
var Input = function (_a) {
    var name = _a.name, handleInputError = _a.handleInputError, icon = _a.icon, iconError = _a.iconError, messageErrorOnBlur = _a.messageErrorOnBlur, isDisabled = _a.isDisabled, rest = __rest(_a, ["name", "handleInputError", "icon", "iconError", "messageErrorOnBlur", "isDisabled"]);
    var inputRef = react_1.useRef(null);
    var _b = core_1.useField(name), fieldName = _b.fieldName, defaultValue = _b.defaultValue, registerField = _b.registerField, error = _b.error, clearError = _b.clearError;
    var _c = __read(react_1.useState(false), 2), success = _c[0], setSuccess = _c[1];
    react_1.useEffect(function () {
        registerField({
            name: fieldName,
            ref: inputRef.current,
            path: 'value',
            setValue: function (ref, value) {
                ref.value = value;
                setSuccess(false);
                clearError();
            },
        });
    }, [fieldName, registerField, clearError]);
    var handleBlur = react_1.useCallback(function (event) {
        if (!event.target.value) {
            if (!!handleInputError && !!messageErrorOnBlur) {
                handleInputError({
                    inputName: name,
                    message: messageErrorOnBlur,
                });
            }
        }
        else
            setSuccess(true);
    }, [handleInputError, messageErrorOnBlur, name]);
    return (jsx_runtime_1.jsxs(styles_1.Container, __assign({ error: !!error, success: success }, { children: [jsx_runtime_1.jsxs("div", __assign({ className: "input-wrapper" }, { children: [jsx_runtime_1.jsx("input", __assign({ name: name, ref: inputRef, defaultValue: defaultValue, onBlur: handleBlur, onFocus: function () {
                            clearError();
                            setSuccess(false);
                        }, onKeyPress: function () {
                            clearError();
                        } }, rest), void 0),
                    !!icon && (jsx_runtime_1.jsx("div", __assign({ className: "icon" }, { children: jsx_runtime_1.jsx("img", { src: error ? iconError || icon : icon, alt: name }, void 0) }), void 0))] }), void 0),
            !!error && messageErrorOnBlur && (jsx_runtime_1.jsx("div", __assign({ className: "error" }, { children: jsx_runtime_1.jsx("p", { children: error }, void 0) }), void 0))] }), void 0));
};
exports.default = Input;
//# sourceMappingURL=index.js.map